export default "__VITE_ASSET__dWQdY7DP__"